import { useState } from "react";
import { Card, styled, Typography } from "~/common/mui";
import { LinkButton } from "~/common/components/Link";
import { C_ON_SURFACE, C_SURFACE } from "~/common/components/icon/Colors";
import MMDDialog, { type MMDFormValues } from "~/features/productDetails/components/MMDAssistant/MMDDialog";
import { useTranslation } from "react-i18next";
import BoxAdd from "~/common/mui/icons/BoxAdd";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";

interface Props {
  isPDP?: boolean;
  marketDesignation: string;
  initialData?: Partial<MMDFormValues>;
  className?: string;
  variant?: "elevation" | "outlined";
  elevation?: number;
}

export default function MMDAssistant(props: {
  isPDP?: boolean;
  marketDesignation: string;
  initialData?: Partial<MMDFormValues>;
  className?: string;
  variant?: "elevation" | "outlined";
  elevation?: number;
}) {
  const [showMMDAssistant, setShowMMDAssistant] = useState(false);

  const { t } = useTranslation();

  const { isPDP = true, marketDesignation, elevation = 1, variant = "elevation" } = props;

  const isDesktop = useIsMinDesktopSize();

  if (!isDesktop) {
    return null;
  }

  return (
    <>
      <StyledCard variant={variant} elevation={elevation} isPDP={isPDP} className={props.className}>
        <BoxAdd fontSize="large" sx={{ fill: C_ON_SURFACE }} />
        <Typography variant={"bodyLarge"} sx={{ mx: 2 }}>
          {t("feature.mmd.assistant.message")}
        </Typography>
        <LinkButton
          onClick={() => {
            setShowMMDAssistant(true);
          }}
        >
          {t("feature.mmd.assistant.seemore")}
        </LinkButton>
      </StyledCard>

      {showMMDAssistant && (
        <MMDDialog
          open={showMMDAssistant}
          onClose={() => setShowMMDAssistant(false)}
          marketDesignation={marketDesignation}
          initialData={props.initialData}
        />
      )}
    </>
  );
}

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== "isPDP",
})<{ isPDP: boolean }>(({ theme, isPDP }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: C_SURFACE,
  padding: "16px",
  // TODO - Margin should not be part of the component
  margin: isPDP ? 0 : 16,
  marginTop: isPDP ? 0 : 8,
}));
